module.exports = __webpack_public_path__ + "static/img/wx-cd.bf30843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wx-cd.png
// module id = j2YX
// module chunks = 27